import { alpha, Box, Typography, useTheme } from '@mui/material'

import rem from '~/utils/ui'

/**
 * A single labeled, monospace prompt block. Shared between the Prompt Audit
 * modal's raw view and the simulation prompt preview so both present the
 * system prompt and the assembled prompt identically.
 */
export default function RawMessageBlock({
  label,
  content,
}: {
  label: string
  content: string
}) {
  const theme = useTheme()
  return (
    <Box sx={{ mt: rem(12) }}>
      <Typography
        variant="overline"
        sx={{
          display: 'block',
          mb: rem(4),
          fontWeight: theme.typography.fontWeightBold,
          letterSpacing: '0.08em',
          color: theme.palette.tertiary1,
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          p: rem(12),
          backgroundColor: theme.palette.tertiary3,
          borderRadius: rem(8),
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: alpha(theme.palette.mainFont, 0.7),
            whiteSpace: 'pre-wrap',
            fontFamily: 'monospace',
            fontSize: rem(12),
          }}
        >
          {content}
        </Typography>
      </Box>
    </Box>
  )
}
